module.exports = __webpack_public_path__ + "static/img/The Sun.7d84c51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Sun.jpg
// module id = 1322
// module chunks = 0